/* eslint-disable max-len */

export const GroupIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden
  >
    <path
      d="M12 13.3c1.4 0 2.7.5 4.1 1.4.5.3.8.9.9 1.5v3.6c-1.7.8-3.3 1.3-5 1.3-1.5 0-3.1-.4-4.6-1.1l-.4-.3v-3.4c0-.7.3-1.3.9-1.7 1.4-.9 2.7-1.3 4.1-1.3zm6-3.1c.9 0 1.8.2 2.6.5s1.3.9 1.3 1.7v3c-1.2.6-2.4 1-3.7 1h-.3V16c0-1.1-.6-2.2-1.7-2.7-.7-.3-1.4-.6-2.1-.8.7-.5 1.2-1.2 1.5-2 .9-.2 1.7-.3 2.4-.3zm-12 0c.7 0 1.5.1 2.2.3.3.8.8 1.5 1.5 2-.7.2-1.3.5-2 .8C6.6 13.8 6 14.9 6 16v.4c-1.2 0-2.4-.3-3.7-.8l-.3-.2v-2.8c0-.9.5-1.6 1.4-1.9.8-.4 1.7-.5 2.6-.5zm6-4.1c1.7 0 3 1.4 3 3.1 0 1.7-1.3 3.1-3 3.1s-3-1.4-3-3.1c0-1.7 1.3-3.1 3-3.1zM6 4c1.4 0 2.5 1.2 2.5 2.6C8.5 8 7.4 9.2 6 9.2S3.5 8 3.5 6.6C3.5 5.2 4.6 4 6 4zm12 0c1.4 0 2.5 1.2 2.5 2.6 0 1.4-1.1 2.6-2.5 2.6S15.5 8 15.5 6.6C15.5 5.2 16.6 4 18 4z"
      fill="#1E4878"
    />
  </svg>
);
